import classnames from "classnames";
import React from "react";
import DownArrow from "src/documentList/descending.svg";
import { ENTITY_COLUMNS, EntitySort } from "./types";

export interface EntityListColumnHeaderProps {
  entityColumn: ENTITY_COLUMNS;
  entitySort: EntitySort;
  className?: string;
  updateSort: (sortColumn: ENTITY_COLUMNS) => void;
}

export const EntityListColumnHeader: React.SFC<EntityListColumnHeaderProps> = ({
  entityColumn,
  entitySort,
  className,
  updateSort
}) => {
  const entityColumnText = entityColumn.toUpperCase();
  const changeSort = () => updateSort(entityColumn);

  return (
    <div className={className} onClick={changeSort}>
      <span className="Entity__list__header__item__content">
        {entityColumnText}
      </span>
      {entitySort.sortColumn === entityColumn && (
        <img
          className={classnames("arrowDown", {
            arrowUp: entitySort.sortAscending
          })}
          src={DownArrow}
        />
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/entityList/EntityListColumnHeader.tsx